var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg75(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "23px",
    viewBox: "0 0 22 23",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0667 22.7586C8.26667 22.7586 5.46667 21.6861 3.2 19.4068C1.06667 17.2617 0 14.4462 0 11.3626C0 8.27891 1.2 5.46341 3.2 3.31827L3.2 3.31827L3.2 3.31827C7.46667 -1.10609 14.5333 -1.10609 18.8 3.31827C20.9333 5.46341 22 8.27891 22 11.3626C22 14.4462 20.8 17.2617 18.8 19.4068C16.8 21.552 13.8667 22.7586 11.0667 22.7586ZM10.9346 1.51724C8.44946 1.51724 6.09512 2.43924 4.26397 4.41494L4.26397 4.41494C2.43282 6.25894 1.51724 8.7615 1.51724 11.3958C1.51724 14.0301 2.56361 16.5326 4.26397 18.3766C7.92628 22.1963 13.9429 22.1963 17.736 18.3766C19.5672 16.5326 20.4828 14.0301 20.4828 11.3958C20.4828 8.7615 19.4364 6.25894 17.736 4.41494C15.7741 2.43924 13.4197 1.51724 10.9346 1.51724Z",
    id: "Shape",
    fill: "#000000",
    stroke: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg75);
export default __webpack_public_path__ + "static/media/75.1772dcfe34929e28e8bef07b1da0d04d.svg";
export { ForwardRef as ReactComponent };